/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import IngresoSelectMultipleIcono from "../../Modulo_formularios/Componentes/IngresoSelectMultipleIcono";
import IngresoSelectMultipleObjeto from "../../Modulo_formularios/Componentes/IngresoSelectMultipleObjeto";
import Tarjeta_Producto from "../Tarjeta/Tarjeta_Producto";


const Formulario_Foto_Productos = ({...props}) => {
    const [productos, setProductos] = useState([])

    useEffect(() => {

        let col = props.props.getValues('idColeccion')

        if (col) {
            let w = [where('idColeccion', '==', col)]
            obtenerColWheres({col: 'productos', wheres: w}).then((dox) => {
                if (dox.data && dox.data[0]) {
                    setProductos(dox.data)
                }
            })
        }

    }, [props.props.watch('coleccion')])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoSelectMultipleObjeto {...props} dato={'productos'}  Tarjeta={Tarjeta_Producto} opciones={productos}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Foto_Productos